<template>
    <div class="modal" tabindex="-1" id="edit-lesson-modal">
       <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-custom">
                    <div class="row">
                        <h3> Edit/Create a &nbsp;Lesson</h3>
                    </div> <div class="row">
                    <button type="button" @click="cancel" class="close" title="Close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row" >
                        <div class="col">
                            <h2 class="bg-secondary text-center" v-if="lessondata" v-html="'<strong>Lesson:</strong> ' + lessondata.name"></h2>
                            <div style="visibility:block;">
                            <div class="row mx-auto my-2 d-flex justify-content-center" ><label class="text-dark" for="name">Lesson Name: </label>
                            <input style="max-width:50%;margin:auto;" type="text" v-model="lessondata.name" class="form-control" required /></div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" ><label class="text-dark" for="description">Lesson Description<br/><small>(for the course-creator's benefit)</small></label>
                            <input style="max-width:50%;margin:auto;" type="text" v-model="lessondata.description" class="form-control"  required  /> </div>
                            <div class="row mx-auto my-2  d-flex justify-content-center" ><label class="text-dark" for="blurb_heading">Lesson Blurb Heading</label>
                            <input style="max-width:50%;margin:auto;" type="text" v-model="lessondata.blurb_heading"  class="form-control"  /> </div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" ><label class="text-dark" for="byline">Lesson By-Line</label>
                            <input style="max-width:50%;margin:auto;" type="text" v-model="lessondata.byline" class="form-control"  required  /> </div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" ><label class="text-dark" for="videourl">Video URL</label>
                            <input style="max-width:50%;margin:auto;" type="text" v-model="lessondata.videourl" class="form-control"   /> </div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" ><label class="text-dark" for="order_num">Order</label>
                            <input style="max-width:50%;margin:auto;" type="number" v-model="lessondata.order_num" class="form-control"   /> </div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" ><label class="text-dark" for="sel_image">Display Image(if needed)</label>
                            <select class="form-control" style="max-width:50%;margin:auto;" v-model="lessondata.image_id" @change="setupImage(lessondata.image_id)" >
                                <option value=''>Please Select</option>
                                <option v-for="image in imageList" :key="image.id" v-bind:value="image.id">{{image.file_name}}</option>
                            </select> </div>
                            <div id="imageDisplay1"></div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" >
                                <label class="text-dark" for="sel_download_id">Downloadable File</label>
                                <select class="form-control" @change="setupDownload" style="max-width:50%;margin:auto;" v-model="lessondata.download_id">
                                    <option value=''>Please Select</option>
                                    <option v-for="dwnload in downloadList" :key="dwnload.id" v-bind:value="dwnload.id">{{dwnload.display_title}}</option>
                                </select>
                            </div>
                    </div>

                        <label class="modal-title text-bold">intro_text:</label>
                        <lessonIntro ref="lessonInp"
                            :api-key="apikey"
                            cloud-channel="6"
                            :disabled=false
                            id="lessInputID"
                            :init= "getInitMenuPlugins()"
                            :inline=false
                            model-events= ""
                            plugins=""
                            tag-name="div"
                            toolbar=""
                            value=""
                            name="intro_text"
                            v-model="lessondata.intro_text"
                        />
                    <label class="modal-title text-bold">main_text:</label>
                        <lessonMain ref="lessonMainInp"
                            :api-key="apikey"
                            cloud-channel="6"
                            :disabled=false
                            id="lessMainID"
                            :init= "getInitMenuPlugins()"
                            :inline=false
                            model-events= ""
                            plugins=""
                            tag-name="div"
                            toolbar=""
                            value=""
                            name="main_text"
                            v-model="lessondata.main_text"
                        />
<div class="row mx-auto d-flex justify-content-center" >
                            <button class="btn btn-lg btn-warning float-right mx-2 my-2" @click="cancel">Close/Discard</button>
                            <button class="btn btn-lg btn-primary float-right  mx-2 my-2" @click="saveLessonAction">Save  Lesson</button> </div>
                    </div>

                        </div>
                    </div>
                    Last updated: {{lessondata.updated_at}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../../event-bus';
import Editor from '@tinymce/tinymce-vue';


import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
        lessonIntro: Editor,
 lessonOther: Editor,
        lessonMain: Editor,
     },
    name: "EditLesson",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            lessondata:{},
            allLessonsData: [],
            lessonid:'',
            currentCourseID: '',
            currentLessonCatID: '',
            imageList:[],
            downloadList: [],
            sel_image_id: '',
            sel_download_id: '',
            sel_download:'',
            sel_image: '',
        }
    },

    props: {
        user:'',
        courses:'',
        lessons:'',
        apikey:'',
        images:'',
        downloads: '',
    },
    mounted() {
            this.userinfo = JSON.parse(this.user);
            this.imageList = JSON.parse(this.images);
            this.downloadList = JSON.parse(this.downloads);
            this.allLessonsData = JSON.parse(this.lessons);
            EventBus.$on('showNewLessonModal', (data) => {
                this.modalReset();
                this.lessondata.owner_id = this.userinfo.id;
                this.currentLessonCatID = data.lessoncat_id;
            console.error(  " lesson new:: new .");
            $('div#edit-lesson-modal').modal('show');
        });

        EventBus.$on('editLessonModal', (data) => {
            this.modalReset();
            this.lessonid = Object.assign({}, data.lessonid);
            this.lessondata = Object.assign({}, data.lessondata);
             this.currentLessonCatID = this.lessondata.lesson_category_id;
            $('div#edit-lesson-modal').modal('show');
        });

        //Helps overcome Bootstrap blocking of the Image input:
        $(document).on('focusin', function(e) {
            if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
                e.stopImmediatePropagation();
            }
            });

    },


    methods: {
    setupImage(imageID) {
    // console.error("setup image: " + imageID);
    //reset image to nothing first
    this.dropImage('imageDisplay1');
    if(this.lessondata.image_id != '') this.displayImage(this.lessondata.image_id);
},
getLesson(lessonid) {
    var theLesson = '';
    [...this.allLessonsData].forEach(aLesson=>{
        if(aLesson.id == lessonid) theLesson = aLesson;
    });
    return theLesson;
},
 setupDownload() {
        this.sel_download = this.getItemByID('pdf', this.sel_download_id);
    },
      getItemByID(itemtype, id) {
        var list = '';
        if(itemtype === 'image') {
            list = this.imageList;
        } else if(itemtype === 'pdf') {
            list = this.downloadList;
        }
        //  console.log("seeking "+itemtype+" with id: " + id);
            return list.find((item)=> {
            //    console.log(item);
                //  console.log(item.id)
                if(item.id == id) {
                    //  console.error("Found " + item.file_name);
                    return item;
                }
            });
        },

    displayImage(id, uri) {
        var tagid = 'imageDisplay1';
        this.dropImage(tagid);
        console.log('displayImage For tag: ' + tagid + ", id: " + id);
        var image = this.getItemByID('image', id);
        var uripath = !uri? image.file_path: uri;
        this.lessondata.image_uri = uripath;
        const html = `<img src='/storage/` + uripath + `' width='100%' >`;
        document.getElementById(tagid).innerHTML = html;
        return image;
    },
    dropImage(tagid) {
        this.lessondata.imag_uri = '';
        document.getElementById(tagid).innerHTML = '';
    },

saveLessonAction() {
            if(this.lessondata.order_num) {
                axios.post('/edu/lesson/saveupdate', {
                    owner_id:this.userinfo.id,
                    id:this.lessondata.id,
                    name:this.lessondata.name,
                    description: this.lessondata.description,
                    blurb_heading: this.lessondata.blurb_heading,
                    byline: this.lessondata.byline,
                    image_id: this.lessondata.image_id,
                    image_uri: this.lessondata.image_uri,
                    download_id: this.lessondata.download_id,
                    main_text: this.lessondata.main_text,
                    intro_text: this.lessondata.intro_text,
                    videourl: this.lessondata.videourl,
                    lessoncat_id: this.currentLessonCatID,
                    order_num: this.lessondata.order_num,
                })
                .then(res => {
                    this.loading = false;
                    this.success = true;
                    this.message = res.data.message;
                    this.updateToast(this.message, 4000);
                    console.error(res.data.message);
                    this.lessondata = JSON.parse(res.data.lesson);
                    // EventBus.$emit('refreshLessonParent');

                })
                .catch(err => {
                    // this.loading = false;
                    // this.failure = true;
                    // this.success = false;
                    console.error(err);
                    this.updateToast(err.message, 4000, 'error');
                })
                .finally(()=> {
                    // location.reload();
                });
            } else {
                this.updateToast("Please check OrderNum. Must be non-null", 4000, 'error');
            }

        },


        modalReset() {
            //set all fields to blank
            this.lessondata.id = '';
            this.lessondata.name = '';
            this.lessondata.byline = '';
            this.lessondata.owner_id = '';
            this.lessondata.description = '';
            this.lessondata.blurb_heading = '';
            this.lessondata.image_id = '';
            this.lessondata.image_uri = '';
            this.lessondata.download_id = '';
            this.lessondata.main_text = '';
            this.lessondata.intro_text = '';
            this.lessondata.order_num = '';
            this.lessondata.videourl = '';

        },
        cancelLessonCat() {
            console.log("Cancel close FSLifeArea");
            $('div#edit-course-modal').modal('hide');
            EventBus.$emit('refreshParentPage');
            // location.reload();
        },
        getTemplate(life_area) {
             console.log("Looking for template with id " + life_area);
            return this.templates.find((template) =>{
                    // console.log(life_area + ' : '+ template.life_area);
                if(template.life_area == life_area) {
                    // console.log("Found template...");
                    return template;
                }
            });
        },
        getInitMenuPlugins() {
            return {
                height: 200,
                menubar: false,
                link_context_toolbar: true,
                image_class_list: [
                    {title: 'Responsive', value: 'img-responsive'}
                ],
                plugins: 'code table lists image',
                toolbar: 'undo redo | formatselect| bold italic | alignleft aligncenter alignright | indent outdent | bullist numlist | link | image code | table'
            }
        },
preventBootstrap() {
    // Prevent Bootstrap dialog from blocking focusin
    $(document).on('focusin', function(e) {
    if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
        e.stopImmediatePropagation();
    }
    });
},

        saveAction() {
            // console.log(this.$refs);
            //console.log(this.$refs.vizInp.value);
            // console.log(this.$refs.planInp.value);
            // console.log(this.$refs.mezInp.value);
            this.saveDetails();
        },

        // saveLessonDetails() {
        //     axios.post('/fself/setup/saveupdate', {
        //         user_id:this.userinfo.id,
        //         id:this.id,
        //         life_area:this.fsModel.life_area,
        //         vision:this.fsModel.vision,
        //         plan:this.fsModel.plan,
        //         measure:this.fsModel.measure,
        //     })
        //     .then(res => {
        //         this.loading = false;
        //         this.success = true;
        //         this.message = res.data.message;
        //         this.updateToast(this.message, 4000);
        //         console.error(res.data.message);
        //     })
        //     .catch(err => {
        //         // this.loading = false;
        //         // this.failure = true;
        //         // this.success = false;

        //     })
        //     .finally(()=> {
        //         // location.reload();
        //     });

        // },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
cancel() {
    // EventBus.$emit('refreshLessonParent');
   $('div#edit-lesson-modal').modal('hide');
}

    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}
</style>
